import { render, staticRenderFns } from "./FavModal.vue?vue&type=template&id=77094b20&scoped=true"
import script from "./FavModal.vue?vue&type=script&lang=js"
export * from "./FavModal.vue?vue&type=script&lang=js"
import style0 from "./FavModal.vue?vue&type=style&index=0&id=77094b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77094b20",
  null
  
)

export default component.exports